import get from 'lodash/get';

export default function selector(storeState) {
    const audienceSegments = get(storeState, 'customDevelopedDashboard.audienceSegments');
    const totalSegmentCount = get(storeState, 'customDevelopedDashboard.totalSegmentCount');
    const isLoading = get(storeState, 'customDevelopedDashboard.isLoading');
    const organizationId = get(storeState, 'profile.organizationId');

    return {
        audienceSegments,
        totalSegmentCount,
        isLoading,
        organizationId,
    };
}
